import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 定型文一覧
 *
 * ログインユーザーの定型文を並び順で返す。初回アクセス時はデフォルトの定型文を投入する
 */
export class FetchTalkTemplate implements APIRequest<Monitaro.FetchTalkTemplateResponse> {
  response: Monitaro.FetchTalkTemplateResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor() {
    this.path = `/talks/templates`
  }
}

/**
 * 定型文の追加
 *
 * ログインユーザーの定型文を追加する
 */
export class PostTalkTemplate implements APIRequest<Monitaro.PostTalkTemplateResponse> {
  response: Monitaro.PostTalkTemplateResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Monitaro.TalkTemplateRequest
  constructor(params: Monitaro.TalkTemplateRequest) {
    this.params = params
    this.path = `/talks/templates`
  }
}

/**
 * 定型文の更新
 *
 * 指定されたIDの定型文を更新する
 */
export class PutTalkTemplate implements APIRequest<Monitaro.PutTalkTemplateResponse> {
  response: Monitaro.PutTalkTemplateResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Monitaro.TalkTemplateRequest
  constructor(template: string, params: Monitaro.TalkTemplateRequest) {
    this.params = params
    this.path = `/talks/templates/${template}`
  }
}

/**
 * 定型文の削除
 *
 * 指定されたIDの定型文を削除する
 */
export class DeleteTalkTemplate implements APIRequest<Monitaro.DeleteTalkTemplateResponse> {
  response: Monitaro.DeleteTalkTemplateResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(template: string) {
    this.path = `/talks/templates/${template}`
  }
}

/**
 * 定型文の並び替え
 *
 * 受け取ったID配列の順に並び順を振り直す
 */
export class SortTalkTemplate implements APIRequest<Monitaro.SortTalkTemplateResponse> {
  response: Monitaro.SortTalkTemplateResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Monitaro.TalkTemplateSortRequest
  constructor(params: Monitaro.TalkTemplateSortRequest) {
    this.params = params
    this.path = `/talks/templates/sort`
  }
}
